<template>
  <div class="page-wrapper">
    <div class="content container-fluid">
      <!-- HEADER -->
      <div class="page-header">
        <div class="row align-items-center">
          <div class="col-sm-8">
            <h3 class="page-title">
              <i class="fa fa-route mr-2 text-primary"></i>
              Điều phối đội xe (mock)
            </h3>
            <ul class="breadcrumb">
              <li class="breadcrumb-item">
                <a href="javascript:void(0)">Dashboard</a>
              </li>
              <li class="breadcrumb-item active">Theo dõi & điều phối</li>
            </ul>
          </div>
        </div>
      </div>

      <!-- TỔNG QUAN / THỐNG KÊ -->
      <div class="row mb-3">
        <div class="col-md-3 mb-2">
          <div class="card stat-card bg-light shadow-sm">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <div class="stat-label">Tổng số xe</div>
                  <div class="stat-value">{{ totalVehicles }}</div>
                </div>
                <div class="stat-icon stat-icon-blue">
                  <i class="fa fa-truck"></i>
                </div>
              </div>
              <div class="stat-sub">
                Rảnh: {{ totalAvailable }} · Đang chạy: {{ totalInUse }} · Bảo dưỡng:
                {{ totalMaintenance }}
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-3 mb-2">
          <div class="card stat-card bg-light shadow-sm">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <div class="stat-label">Đơn đang giao</div>
                  <div class="stat-value">{{ totalDeliveringOrders }}</div>
                </div>
                <div class="stat-icon stat-icon-green">
                  <i class="fa fa-shipping-fast"></i>
                </div>
              </div>
              <div class="stat-sub">
                Giao gấp: {{ totalDeliveringUrgent }}
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-3 mb-2">
          <div class="card stat-card bg-light shadow-sm">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <div class="stat-label">Đơn chờ điều phối</div>
                  <div class="stat-value">{{ waitingOrders.length }}</div>
                </div>
                <div class="stat-icon stat-icon-orange">
                  <i class="fa fa-clock"></i>
                </div>
              </div>
              <div class="stat-sub">
                Tổng trọng tải: {{ totalWaitingWeight }} tấn
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-3 mb-2">
          <div class="card stat-card bg-light shadow-sm">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <div class="stat-label">Xe phù hợp tải trọng cho đơn chờ</div>
                  <div class="stat-value">
                    {{ candidateVehiclesForWaiting.length }}
                  </div>
                </div>
                <div class="stat-icon stat-icon-purple">
                  <i class="fa fa-balance-scale"></i>
                </div>
              </div>
              <div class="stat-sub">
                Đang rảnh: {{ candidateAvailableVehicles.length }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- BODY: LIST XE & CHI TIẾT -->
      <div class="row">
        <!-- LEFT: DANH SÁCH XE -->
        <div class="col-md-4">
          <div class="card shadow-sm">
            <div
              class="card-header d-flex justify-content-between align-items-center"
            >
              <strong>Danh sách xe (mock)</strong>
              <div>
                <small class="text-muted mr-1">Lọc:</small>
                <select
                  v-model="filterTrangThai"
                  class="form-control form-control-sm d-inline-block w-auto"
                >
                  <option value="">Tất cả</option>
                  <option value="AVAILABLE">Rảnh (AVAILABLE)</option>
                  <option value="IN_USE">Đang dùng (IN_USE)</option>
                  <option value="MAINTENANCE">Bảo dưỡng</option>
                </select>
              </div>
            </div>
            <div class="card-body p-0">
              <ul class="list-group list-group-flush">
                <li
                  v-for="xe in filteredVehicles"
                  :key="xe.id"
                  class="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
                  :class="{ active: selectedVehicle && selectedVehicle.id === xe.id }"
                  style="cursor: pointer;"
                  @click="selectVehicle(xe)"
                >
                  <div>
                    <div class="font-weight-bold">
                      {{ xe.bienSo }}
                    </div>
                    <div class="small">
                      <span class="text-muted">
                        {{ xe.loaiXe }} ·
                        {{ xe.tenTaiXe || "Chưa gán tài xế" }}
                      </span>
                    </div>
                    <div class="small text-muted">
                      Tải trọng: {{ xe.taiTrongToiDa }} tấn
                    </div>
                  </div>
                  <div class="text-right">
                    <span class="badge" :class="badgeClass(xe.trangThaiXe)">
                      {{ xe.trangThaiXe }}
                    </span>
                    <div class="small text-muted mt-1">
                      {{ xe.trangThaiTaiXe }}
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>

          <!-- ĐƠN CHỜ ĐIỀU PHỐI (POOL) -->
          <div class="card shadow-sm mt-3">
            <div class="card-header">
              <strong>Đơn chờ điều phối (mock)</strong>
            </div>
            <div class="card-body p-0">
              <div v-if="!waitingOrders.length" class="p-3 text-muted">
                Không có đơn nào chờ điều phối.
              </div>
              <div v-else class="table-responsive">
                <table class="table table-sm mb-0">
                  <thead class="thead-light">
                    <tr>
                      <th style="width: 20px;"></th> <!-- 👈 thêm checkbox -->
                      <th>#</th>
                      <th>Đơn</th>
                      <th>Tải (tấn)</th>
                      <th>Phù hợp xe?</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr v-for="don in waitingOrders" :key="don.id">
                      <td>
                        <input
                          type="checkbox"
                          v-model="selectedWaitingOrderIds"
                          :value="don.id"
                        />
                      </td>
                      <td>{{ don.id }}</td>
                      <td>
                        <div class="font-weight-bold">{{ don.tenDonHang }}</div>
                        <div class="small text-muted">
                          {{ don.diaChiGiaoHang }}
                        </div>
                      </td>
                      <td>{{ don.tongKhoiLuong }}</td>
                      <td>
                        <span
                          v-if="hasAnyVehicleForOrder(don)"
                          class="badge badge-success"
                        >
                          Có xe
                        </span>
                        <span v-else class="badge badge-danger">
                          Không đủ tải
                        </span>
                      </td>
                    </tr>
                  </tbody>

                </table>
              </div>
             <div
                class="p-2 border-top d-flex justify-content-between align-items-center"
              >
                <div class="small text-muted">
                  Gợi ý: chọn một xe ở trên, tick các đơn bên dưới rồi bấm “Gán vào xe”.
                </div>
                <button
                  class="btn btn-sm btn-primary"
                  :disabled="
                    !selectedVehicle ||
                    !selectedWaitingOrderIds.length ||
                    isAssigning
                  "
                  @click="assignToSelectedVehicle"
                >
                  <span
                    v-if="isAssigning"
                    class="spinner-border spinner-border-sm mr-1"
                  ></span>
                  Gán {{ selectedWaitingOrderIds.length }} đơn vào xe này
                </button>
              </div>
              <div v-if="assignError" class="px-2 pb-2 text-danger small">
                {{ assignError }}
              </div>

            </div>
          </div>
        </div>

        <!-- RIGHT: CHI TIẾT XE + ĐƠN + GPS -->
        <div class="col-md-8 mt-3 mt-md-0">
          <!-- THÔNG TIN XE -->
          <div class="card shadow-sm mb-3">
            <div class="card-header d-flex justify-content-between align-items-center">
              <div>
                <strong>Thông tin xe</strong>
                <span v-if="selectedVehicle" class="ml-2">
                  ({{ selectedVehicle.bienSo }})
                </span>
              </div>

              <button
                v-if="selectedVehicle"
                class="btn btn-sm btn-danger"
                @click="openEmergencyModal"
              >
                <i class="fa fa-bolt mr-1"></i>
                Điều động khẩn
              </button>
            </div>
            <div class="card-body">
              <div v-if="!selectedVehicle" class="text-muted">
                Chọn một xe ở danh sách bên trái để xem chi tiết.
              </div>

              <div v-else>
                <h5 class="mb-1">
                  <i class="fa fa-truck mr-2 text-primary"></i>
                  {{ selectedVehicle.bienSo }}
                </h5>
                <p class="mb-1">
                  <strong>Loại xe:</strong> {{ selectedVehicle.loaiXe }}
                </p>
                <p class="mb-1">
                  <strong>Tải trọng tối đa:</strong>
                  {{ selectedVehicle.taiTrongToiDa }} tấn
                </p>
                <p class="mb-1">
                  <strong>Trạng thái xe (workflow):</strong>
                  <span class="badge" :class="badgeClass(selectedVehicle.trangThaiXe)">
                    {{ selectedVehicle.trangThaiXe }}
                  </span>
                </p>
                <p class="mb-1">
                  <strong>Tài xế:</strong>
                  <span v-if="selectedVehicle.tenTaiXe">
                    {{ selectedVehicle.tenTaiXe }}
                    <span v-if="selectedVehicle.sdtTaiXe">
                      ({{ selectedVehicle.sdtTaiXe }})
                    </span>
                  </span>
                  <span v-else class="text-muted">Chưa gán tài xế</span>
                </p>
                <p class="mb-0 text-muted">
                  <strong>Trạng thái tài xế (suy ra từ đơn & điểm dừng):</strong>
                  {{ selectedVehicle.trangThaiTaiXe }}
                </p>
              </div>
            </div>
          </div>

          <!-- GPS THỰC TẾ CỦA XE -->
          <XeGpsTrangThai
            :plate="selectedVehicle ? normalizePlate(selectedVehicle.bienSo) : null"
          />

          <!-- BẢNG ĐƠN HÀNG CỦA XE + TẢI TRỌNG -->
          <div class="card shadow-sm mb-3" v-if="selectedVehicle">
            <div class="card-header">
              <strong>Đơn hàng của xe này (mock)</strong>
            </div>
            <div class="card-body p-0">
              <div
                v-if="
                  !selectedVehicle.orders || !selectedVehicle.orders.length
                "
                class="p-3 text-muted"
              >
                Xe hiện không có đơn DANG_VAN_CHUYEN.
              </div>
              <div v-else class="table-responsive">
                <table class="table table-sm mb-0">
                  <thead class="thead-light">
                    <tr>
                      <th>#</th>
                      <th>Đơn hàng</th>
                      <th>Trạng thái</th>
                      <th>Điểm dừng hiện tại</th>
                      <th>Địa chỉ điểm dừng</th>
                      <th>Tải đơn (tấn)</th>
                      <th>So với tải xe</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="don in selectedVehicle.orders" :key="don.id">
                      <td>{{ don.id }}</td>
                      <td>
                        <div class="font-weight-bold">{{ don.tenDonHang }}</div>
                        <div class="small text-muted">
                          Loại: {{ don.loaiDonHang }} ·
                          Giao gấp: {{ don.giaoGap ? "Có" : "Không" }}
                        </div>
                      </td>
                      <td>
                        <span class="badge badge-info">
                          {{ don.trangThai }}
                        </span>
                      </td>
                      <td>
                        <div v-if="don.currentStop">
                          ({{ don.currentStop.thuTu }})
                          {{ don.currentStop.tenDiemDung }}
                          <div class="small text-muted">
                            {{ don.currentStop.loaiDiemDung }} ·
                            {{ don.currentStop.trangThai }}
                          </div>
                        </div>
                        <div v-else class="small text-muted">
                          Không xác định được điểm dừng hiện tại
                        </div>
                      </td>
                      <td>
                        <div v-if="don.currentStop">
                          {{ don.currentStop.diaChi }}
                        </div>
                        <div v-else class="small text-muted">N/A</div>
                      </td>
                      <td>
                        {{ don.tongKhoiLuong }}
                      </td>
                      <td>
                        <span
                          v-if="don.tongKhoiLuong <= selectedVehicle.taiTrongToiDa"
                          class="badge badge-success"
                        >
                          OK (≤ {{ selectedVehicle.taiTrongToiDa }} t)
                        </span>
                        <span v-else class="badge badge-danger">
                          Quá tải
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- Chi tiết điểm dừng từng đơn -->
              <div class="p-3 border-top">
                <h6 class="text-uppercase text-muted small mb-2">
                  Chi tiết điểm dừng từng đơn
                </h6>
                <div
                  v-for="don in selectedVehicle.orders"
                  :key="don.id + '-stops'"
                  class="mb-2"
                >
                  <div class="font-weight-bold small mb-1">
                    Đơn #{{ don.id }} - {{ don.tenDonHang }}
                    ({{ don.tongKhoiLuong }} tấn)
                  </div>
                  <div
                    v-if="don.diemDung && don.diemDung.length"
                    class="table-responsive"
                  >
                    <table class="table table-sm table-bordered mb-1">
                      <thead class="thead-light">
                        <tr>
                          <th>TT</th>
                          <th>Loại điểm</th>
                          <th>Tên điểm</th>
                          <th>Địa chỉ</th>
                          <th>Trạng thái</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="st in don.diemDung" :key="st.id">
                          <td>{{ st.thuTu }}</td>
                          <td>{{ st.loaiDiemDung }}</td>
                          <td>{{ st.tenDiemDung }}</td>
                          <td>{{ st.diaChi }}</td>
                          <td>{{ st.trangThai }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div v-else class="small text-muted">
                    Không có điểm dừng.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- MODAL ĐIỀU ĐỘNG KHẨN (MOCK) -->
      <div
        v-if="showEmergency"
        class="modal fade show"
        tabindex="-1"
        role="dialog"
        style="display: block;"
      >
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">
                <i class="fa fa-bolt mr-2 text-danger"></i>
                Điều động khẩn cho xe {{ selectedVehicle?.bienSo }}
              </h5>
              <button type="button" class="close" @click="closeEmergencyModal">
                <span>&times;</span>
              </button>
            </div>

            <div class="modal-body">
              <div class="row">
                <div class="col-md-7">
                  <div class="form-group">
                    <label>Loại điều động</label>
                    <select v-model="emForm.loai" class="form-control">
                      <option value="GIAO_KHACH">Giao hàng cho khách</option>
                      <option value="LAY_HOA_SEN">Lấy hàng Hoa Sen</option>
                      <option value="VE_KHO_CHAT_HANG">Về kho chất hàng</option>
                      <option value="KHAC">Khác</option>
                    </select>
                  </div>

                  <div class="form-group">
                    <label>Địa chỉ / mô tả điểm đến</label>
                    <textarea
                      v-model="emForm.diaChi"
                      class="form-control"
                      rows="2"
                      placeholder="VD: Công trình B, Quốc lộ 13, Bình Dương..."
                    ></textarea>
                  </div>

                  <div class="form-row">
                    <div class="form-group col-md-6">
                      <label>Khoảng cách ước tính (km)</label>
                      <input
                        type="number"
                        min="0"
                        step="0.1"
                        v-model.number="emForm.distanceKm"
                        class="form-control"
                        placeholder="VD: 12.5"
                      />
                      <small class="form-text text-muted">
                        Tạm thời nhập tay; sau này sẽ tính từ GPS + địa chỉ.
                      </small>
                    </div>
                    <div class="form-group col-md-6">
                      <label>Thời gian bắt đầu (dự kiến)</label>
                      <input
                        type="datetime-local"
                        v-model="emForm.startTime"
                        class="form-control"
                      />
                    </div>
                  </div>

                  <div class="form-group">
                    <label>Ghi chú thêm</label>
                    <textarea
                      v-model="emForm.ghiChu"
                      class="form-control"
                      rows="2"
                    ></textarea>
                  </div>
                </div>

                <div class="col-md-5">
                  <div class="border rounded p-2 bg-light">
                    <h6 class="text-uppercase small text-muted">
                      Dự toán hành trình & tăng ca (mock)
                    </h6>
                    <p class="mb-1">
                      <strong>Vận tốc TB:</strong> {{ avgSpeed }} km/h
                    </p>
                    <p class="mb-1">
                      <strong>Thời gian dự kiến:</strong>
                      <span v-if="etaMinutes != null">
                        ~ {{ etaMinutes }} phút
                      </span>
                      <span v-else class="text-muted">Chưa có khoảng cách</span>
                    </p>
                    <p class="mb-1" v-if="expectedEndFormatted">
                      <strong>Kết thúc dự kiến:</strong>
                      {{ expectedEndFormatted }}
                    </p>
                    <p class="mb-1" v-if="otAmount != null">
                      <strong>Tiền tăng ca ước tính:</strong>
                      {{ formatMoney(otAmount) }}
                    </p>
                    <p class="small text-muted mb-0">
                      Quy tắc: 17h–23h59: 36k/giờ; 0h–2h: 100k; 2h–4h: 250k. Nếu
                      thực tế vượt quá ~1.5 lần thời gian dự kiến thì hệ thống sẽ
                      (sau này) cảnh báo tài xế có dấu hiệu kéo dài thời gian.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-secondary"
                @click="closeEmergencyModal"
              >
                Đóng
              </button>
              <button
                type="button"
                class="btn btn-danger"
                @click="submitEmergency"
                :disabled="!selectedVehicle"
              >
                <i class="fa fa-check mr-1"></i>
                Tạo lệnh điều động khẩn (mock)
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="showEmergency"
        class="modal-backdrop fade show"
      ></div>
    </div>
  </div>
</template>

<script>
import XeGpsTrangThai from "./XeGpsTrangThai.vue";
import { XeApi } from "@/services/xeService";          
import { DonHangApi } from "@/services/donHangService";

export default {
  name: "XeDispatchMonitorMock",
  components: {
    XeGpsTrangThai,
  },
  // data() {
  //   return {
  //     filterTrangThai: "",
  //     avgSpeed: 40, // km/h

  //     // ==== DATA GIẢ XE + ĐƠN ====
  //     vehicles: [
  //       {
  //         id: 1,
  //         bienSo: "61H06971",
  //         loaiXe: "Tải 2 tấn",
  //         taiTrongToiDa: 2.0,
  //         trangThaiXe: "IN_USE",
  //         tenTaiXe: "Nguyễn Văn B",
  //         sdtTaiXe: "0901 234 567",
  //         trangThaiTaiXe: "Đang giao hàng cho khách",
  //         orders: [
  //           {
  //             id: 3,
  //             tenDonHang: "321",
  //             loaiDonHang: "LAY_HANG",
  //             trangThai: "DANG_VAN_CHUYEN",
  //             giaoGap: false,
  //             tongKhoiLuong: 1.2,
  //             currentStop: {
  //               id: 6,
  //               thuTu: 2,
  //               loaiDiemDung: "KHACH_HANG",
  //               tenDiemDung: "Giao Khách: 123",
  //               diaChi: "123",
  //               trangThai: "DA_DEN",
  //             },
  //             diemDung: [
  //               {
  //                 id: 5,
  //                 thuTu: 1,
  //                 loaiDiemDung: "KHO_LAY",
  //                 tenDiemDung: "123",
  //                 diaChi: "123",
  //                 trangThai: "KHO_DA_XAC_MINH",
  //               },
  //               {
  //                 id: 6,
  //                 thuTu: 2,
  //                 loaiDiemDung: "KHACH_HANG",
  //                 tenDiemDung: "Giao Khách: 123",
  //                 diaChi: "123",
  //                 trangThai: "DA_DEN",
  //               },
  //             ],
  //           },
  //           {
  //             id: 1,
  //             tenDonHang: "5432",
  //             loaiDonHang: "LAY_HANG",
  //             trangThai: "DANG_VAN_CHUYEN",
  //             giaoGap: false,
  //             tongKhoiLuong: 0.5,
  //             currentStop: {
  //               id: 2,
  //               thuTu: 2,
  //               loaiDiemDung: "KHACH_HANG",
  //               tenDiemDung: "Giao Khách: 12312",
  //               diaChi: "12312",
  //               trangThai: "CHO_DEN",
  //             },
  //             diemDung: [
  //               {
  //                 id: 1,
  //                 thuTu: 1,
  //                 loaiDiemDung: "KHO_LAY",
  //                 tenDiemDung: "21321",
  //                 diaChi: "31231",
  //                 trangThai: "DA_SOAN_HANG",
  //               },
  //               {
  //                 id: 2,
  //                 thuTu: 2,
  //                 loaiDiemDung: "KHACH_HANG",
  //                 tenDiemDung: "Giao Khách: 12312",
  //                 diaChi: "12312",
  //                 trangThai: "CHO_DEN",
  //               },
  //             ],
  //           },
  //         ],
  //       },
  //       {
  //         id: 2,
  //         bienSo: "61H15745",
  //         loaiXe: "Tải 5 tấn",
  //         taiTrongToiDa: 5.0,
  //         trangThaiXe: "AVAILABLE",
  //         tenTaiXe: null,
  //         sdtTaiXe: null,
  //         trangThaiTaiXe: "Xe đang rảnh, chưa gán đơn",
  //         orders: [],
  //       },
  //       {
  //         id: 3,
  //         bienSo: "61H00609",
  //         loaiXe: "Xe ben 8 tấn",
  //         taiTrongToiDa: 8.0,
  //         trangThaiXe: "IN_USE",
  //         tenTaiXe: "Trần Văn C",
  //         sdtTaiXe: "0909 888 999",
  //         trangThaiTaiXe: "Đang trên đường đến kho lấy hàng",
  //         orders: [
  //           {
  //             id: 10,
  //             tenDonHang: "Giao cát nền",
  //             loaiDonHang: "GIAO_HANG",
  //             trangThai: "DANG_VAN_CHUYEN",
  //             giaoGap: true,
  //             tongKhoiLuong: 6.5,
  //             currentStop: {
  //               id: 100,
  //               thuTu: 1,
  //               loaiDiemDung: "KHO_LAY",
  //               tenDiemDung: "Kho VLXD Bình Dương",
  //               diaChi: "Đường số 1, KCN VSIP 2",
  //               trangThai: "DA_SOAN_HANG",
  //             },
  //             diemDung: [
  //               {
  //                 id: 100,
  //                 thuTu: 1,
  //                 loaiDiemDung: "KHO_LAY",
  //                 tenDiemDung: "Kho VLXD Bình Dương",
  //                 diaChi: "Đường số 1, KCN VSIP 2",
  //                 trangThai: "DA_SOAN_HANG",
  //               },
  //               {
  //                 id: 101,
  //                 thuTu: 2,
  //                 loaiDiemDung: "KHACH_HANG",
  //                 tenDiemDung: "Công trình A",
  //                 diaChi: "Đường 30/4, Thủ Dầu Một",
  //                 trangThai: "CHO_DEN",
  //               },
  //             ],
  //           },
  //         ],
  //       },
  //       {
  //         id: 4,
  //         bienSo: "61H03378",
  //         loaiXe: "Đầu kéo 30 tấn",
  //         taiTrongToiDa: 30.0,
  //         trangThaiXe: "MAINTENANCE",
  //         tenTaiXe: "Lê Văn D",
  //         sdtTaiXe: "0912 345 678",
  //         trangThaiTaiXe: "Xe đang bảo dưỡng",
  //         orders: [],
  //       },
  //     ],

  //     selectedVehicle: null,

  //     // GPS giả theo biển số (tạm dùng cho hiển thị / sau map)
  //     gpsByPlate: {
  //       "61H06971": {
  //         Plate: "61H06971",
  //         Id: "06971",
  //         GroupName: "ctyminhtien",
  //         Lat: 11.064805,
  //         Lng: 106.644493,
  //         Speed: 0.0,
  //         IsStop: true,
  //         Address:
  //           "Đường Mỹ Phước - Tân Vạn, Tân Định, Tx. Bến Cát, Bình Dương, Vietnam",
  //         TimeUpdate: "2025/11/04 13:17:15",
  //       },
  //       "61H03378": {
  //         Plate: "61H03378",
  //         Id: "10001",
  //         GroupName: "teamHCM",
  //         Lat: 10.800123,
  //         Lng: 106.700456,
  //         Speed: 35.5,
  //         IsStop: false,
  //         Address: "Xa lộ Hà Nội, Thủ Đức, TP.HCM",
  //         TimeUpdate: "2025/11/04 13:20:00",
  //       },
  //       "61H00609": {
  //         Plate: "61H00609",
  //         Id: "20001",
  //         GroupName: "teamDongNai",
  //         Lat: 10.950001,
  //         Lng: 106.820001,
  //         Speed: 12.3,
  //         IsStop: false,
  //         Address: "QL1A, Biên Hòa, Đồng Nai",
  //         TimeUpdate: "2025/11/04 13:19:30",
  //       },
  //       "61H15745": {
  //         Plate: "61H15745",
  //         Id: "30001",
  //         GroupName: "teamTayNinh",
  //         Lat: 11.300001,
  //         Lng: 106.100001,
  //         Speed: 0,
  //         IsStop: true,
  //         Address: "Garage Minh Tín, Tây Ninh",
  //         TimeUpdate: "2025/11/04 10:00:00",
  //       },
  //     },

  //     // Đơn chờ điều phối (mock)
  //     waitingOrders: [
  //       {
  //         id: 20,
  //         tenDonHang: "Giao xi măng công trình B",
  //         diaChiGiaoHang: "Quốc lộ 13, Bình Dương",
  //         tongKhoiLuong: 4.0,
  //       },
  //       {
  //         id: 21,
  //         tenDonHang: "Giao sắt thép công trình C",
  //         diaChiGiaoHang: "Long Thành, Đồng Nai",
  //         tongKhoiLuong: 10.0,
  //       },
  //     ],

  //     // Modal điều động khẩn
  //     showEmergency: false,
  //     emForm: {
  //       loai: "GIAO_KHACH",
  //       diaChi: "",
  //       distanceKm: null,
  //       startTime: "",
  //       ghiChu: "",
  //     },
  //   };
  // },

  data() {
    return {
      filterTrangThai: "",
      avgSpeed: 40, // km/h

      // DỮ LIỆU THẬT
      vehicles: [],
      selectedVehicle: null,

      gpsByPlate: {},

      // Đơn chờ điều phối
      waitingOrders: [],

      // Chọn đơn trong pool để gán
      selectedWaitingOrderIds: [],   // 👈 NEW
      isAssigning: false,            // 👈 NEW
      assignError: null,             // 👈 NEW

      // Modal điều động khẩn
      showEmergency: false,
      emForm: {
        loai: "GIAO_KHACH",
        diaChi: "",
        distanceKm: null,
        startTime: "",
        ghiChu: "",
      },
    };
  },


  computed: {
    totalWaitingWeight() {
      return this.waitingOrders
        .map((o) => o.tongKhoiLuong || 0)
        .reduce((a, b) => a + b, 0);
    },

    selectedGps() {
      if (!this.selectedVehicle) return null;
      return this.gpsByPlate[this.selectedVehicle.bienSo] || null;
    },
    filteredVehicles() {
      if (!this.filterTrangThai) return this.vehicles;
      return this.vehicles.filter((v) => v.trangThaiXe === this.filterTrangThai);
    },
    // ==== THỐNG KÊ ====
    totalVehicles() {
      return this.vehicles.length;
    },
    totalAvailable() {
      return this.vehicles.filter((v) => v.trangThaiXe === "AVAILABLE").length;
    },
    totalInUse() {
      return this.vehicles.filter((v) => v.trangThaiXe === "IN_USE").length;
    },
    totalMaintenance() {
      return this.vehicles.filter((v) => v.trangThaiXe === "MAINTENANCE").length;
    },
    totalDeliveringOrders() {
      return this.vehicles.reduce(
        (sum, v) =>
          sum +
          v.orders.filter((o) => o.trangThai === "DANG_VAN_CHUYEN").length,
        0
      );
    },
    totalDeliveringUrgent() {
      return this.vehicles.reduce(
        (sum, v) =>
          sum +
          v.orders.filter(
            (o) => o.trangThai === "DANG_VAN_CHUYEN" && o.giaoGap
          ).length,
        0
      );
    },
    totalWaitingWeight() {
      return this.waitingOrders
        .map((o) => o.tongKhoiLuong)
        .reduce((a, b) => a + b, 0);
    },
    candidateVehiclesForWaiting() {
      return this.vehicles.filter((v) =>
        this.waitingOrders.some((o) => o.tongKhoiLuong <= v.taiTrongToiDa)
      );
    },
    candidateAvailableVehicles() {
      return this.candidateVehiclesForWaiting.filter(
        (v) => v.trangThaiXe === "AVAILABLE"
      );
    },

    // ==== TÍNH TOÁN CHO ĐIỀU ĐỘNG KHẨN ====
    etaMinutes() {
      if (!this.emForm.distanceKm || this.emForm.distanceKm <= 0) return null;
      const minutes = (this.emForm.distanceKm / this.avgSpeed) * 60;
      return Math.round(minutes);
    },
    expectedEnd() {
      if (!this.emForm.startTime || this.etaMinutes == null) return null;
      const start = new Date(this.emForm.startTime);
      if (isNaN(start.getTime())) return null;
      return new Date(start.getTime() + this.etaMinutes * 60000);
    },
    expectedEndFormatted() {
      if (!this.expectedEnd) return null;
      const d = this.expectedEnd;
      const pad = (n) => (n < 10 ? "0" + n : n);
      return (
        pad(d.getDate()) +
        "/" +
        pad(d.getMonth() + 1) +
        " " +
        pad(d.getHours()) +
        ":" +
        pad(d.getMinutes())
      );
    },
    otAmount() {
      if (!this.emForm.startTime || !this.expectedEnd) return null;
      return this.calcOtPay(
        new Date(this.emForm.startTime),
        this.expectedEnd
      );
    },
  },
  methods: {
async loadVehiclesAndOrders() {
    try {
      // 1. Lấy danh sách xe + trạng thái + tài xế
      const xeStatusList = await DonHangApi.getXeOptionsStatus();
      // hiện tại DTO: { id, bienSo, trangThai, taiXeDuocPhanCongId, tenTaiXeDuocPhanCong, ... }

      // 2. Lấy danh sách đơn đang vận chuyển
      const resRunning = await DonHangApi.listAll({
        trangThai: "DANG_VAN_CHUYEN",
        page: 0,
        size: 200,
      });
      const runningOrders = resRunning.content || [];

      // 3. Group đơn theo xeId
      const ordersByXeId = {};
      runningOrders.forEach((dh) => {
        const xeId = dh.xeId;
        if (!xeId) return;
        if (!ordersByXeId[xeId]) {
          ordersByXeId[xeId] = [];
        }

        ordersByXeId[xeId].push({
          id: dh.id,
          tenDonHang: dh.tenDonHang,
          loaiDonHang: dh.loaiDonHang,
          trangThai: dh.trangThai,             // "DANG_VAN_CHUYEN"
          giaoGap: dh.giaoGap,
          tongKhoiLuong: dh.tongKhoiLuong || 0, // nhớ map field này ở backend
          currentStop: dh.currentStop || null,  // nếu backend có
          diemDung: dh.diemDung || [],
          phanCongId: dh.phanCongId || null,    // 👈 GIỮ LẠI PHÂN CÔNG
        });
      });

      // 4. Build vehicles cho UI
      this.vehicles = xeStatusList.map((x) => {
        const orders = ordersByXeId[x.id] || [];

        const loaiXe = x.tenLoaiXe || x.loaiXe || "Chưa rõ loại";
        const taiTrongToiDa = x.taiTrongToiDa || 0;

        // 👇 ƯU TIÊN DÙNG activePhanCongId TỪ BACKEND, NẾU CHƯA CÓ THÌ SUY RA TỪ ĐƠN
        let activePhanCongId = x.activePhanCongId || null;
        if (!activePhanCongId && orders.length) {
          const firstWithPc = orders.find((o) => o.phanCongId);
          if (firstWithPc) {
            activePhanCongId = firstWithPc.phanCongId;
          }
        }

        let trangThaiTaiXeText;
        if (orders.length) {
          trangThaiTaiXeText = `Đang giao ${orders.length} đơn`;
        } else if (x.trangThai === "AVAILABLE") {
          trangThaiTaiXeText = "Xe đang rảnh, chưa gán đơn";
        } else if (x.trangThai === "IN_USE") {
          trangThaiTaiXeText = "Đang sử dụng nhưng chưa nhận đơn";
        } else {
          trangThaiTaiXeText = "Không rõ";
        }

        return {
          id: x.id,
          bienSo: x.bienSo,                         // VD: "61H 006.09"
          loaiXe,
          taiTrongToiDa,
          trangThaiXe: x.trangThai || "AVAILABLE",
          tenTaiXe: x.tenTaiXeDuocPhanCong || null,
          sdtTaiXe: x.sdtTaiXe || null,
          trangThaiTaiXe: trangThaiTaiXeText,
          activePhanCongId,                        // 👈 GIỜ KHÔNG CÒN NULL NỮA
          orders,
        };
      });

      if (!this.selectedVehicle && this.vehicles.length > 0) {
        this.selectedVehicle = this.vehicles[0];
      }
    } catch (e) {
      console.error("Lỗi loadVehiclesAndOrders", e);
    }
  },

  async loadWaitingOrders() {
    try {
      const resPool = await DonHangApi.listPool({
        page: 0,
        size: 50,
      });
      const content = resPool.content || [];

      this.waitingOrders = content.map((dh) => ({
        id: dh.id,
        tenDonHang: dh.tenDonHang,
        diaChiGiaoHang: dh.diaChiGiaoHang,
        tongKhoiLuong: dh.tongKhoiLuong || 0,
      }));
    } catch (e) {
      console.error("Lỗi loadWaitingOrders", e);
      this.waitingOrders = [];
    }
  },

    async assignToSelectedVehicle() {
      if (!this.selectedVehicle) {
        alert("Vui lòng chọn một xe ở danh sách bên trái.");
        return;
      }
      if (!this.selectedWaitingOrderIds.length) {
        alert("Vui lòng chọn ít nhất 1 đơn trong danh sách chờ điều phối.");
        return;
      }
      console.log("xe check: ", this.selectedVehicle)

      const phanCongId = this.selectedVehicle.activePhanCongId;
      if (!phanCongId) {
        alert(
          "Xe này chưa có lệnh phân công đang hoạt động (ASSIGNED/IN_USE). " +
          "Vui lòng tạo lệnh phân công hoặc điều động khẩn trước."
        );
        return;
      }

  this.isAssigning = true;
  this.assignError = null;
  try {
    await DonHangApi.adminAssignDonHang(
      phanCongId,
      this.selectedWaitingOrderIds
    );

    // reload lại data sau khi gán
    await this.loadVehiclesAndOrders();
    await this.loadWaitingOrders();
    this.selectedWaitingOrderIds = [];

    alert("Đã gán đơn vào chuyến của xe.");
  } catch (e) {
    console.error("assignToSelectedVehicle error", e);
    this.assignError =
      e?.response?.data?.message || "Lỗi khi gán đơn cho xe.";
    alert(this.assignError);
  } finally {
    this.isAssigning = false;
  }
},



    normalizePlate(bienSo) {
    if (!bienSo) return null;
    // Bỏ khoảng trắng và dấu chấm: "61H 157.45" -> "61H15745"
    return bienSo.replace(/[\s.]/g, "");
  },

    selectVehicle(xe) {
      this.selectedVehicle = xe;
    },
    badgeClass(trangThaiXe) {
      switch (trangThaiXe) {
        case "IN_USE":
          return "badge-success";
        case "AVAILABLE":
          return "badge-primary";
        case "MAINTENANCE":
          return "badge-warning";
        case "DECOMMISSIONED":
          return "badge-dark";
        default:
          return "badge-secondary";
      }
    },
    hasAnyVehicleForOrder(order) {
      return this.vehicles.some(
        (v) => v.taiTrongToiDa >= order.tongKhoiLuong
      );
    },

    // ==== MODAL ĐIỀU ĐỘNG KHẨN ====
    openEmergencyModal() {
      if (!this.selectedVehicle) return;
      const now = new Date();
      // datetime-local format yyyy-MM-ddTHH:mm
      const local = new Date(now.getTime() - now.getTimezoneOffset() * 60000)
        .toISOString()
        .slice(0, 16);

      this.emForm = {
        loai: "GIAO_KHACH",
        diaChi: "",
        distanceKm: null,
        startTime: local,
        ghiChu: "",
      };
      this.showEmergency = true;
    },
    closeEmergencyModal() {
      this.showEmergency = false;
    },
    submitEmergency() {
      if (!this.selectedVehicle) return;
      // mock: log ra console, sau này gọi API
      console.log("LỆNH ĐIỀU ĐỘNG KHẨN (MOCK)", {
        xe: this.selectedVehicle,
        form: this.emForm,
        etaMinutes: this.etaMinutes,
        expectedEnd: this.expectedEnd,
        otAmount: this.otAmount,
      });
      alert("Đã tạo lệnh điều động khẩn (mock). Sau này sẽ lưu xuống backend.");
      this.showEmergency = false;
    },

    formatMoney(n) {
      if (n == null) return "";
      return n.toLocaleString("vi-VN") + " đ";
    },

    /**
     * Tính tiền tăng ca:
     * - 17:00–23:59: 36k/giờ (tính theo số giờ thực trong khoảng)
     * - 00:00–02:00: nếu có chạy trong khung này -> +100k
     * - 02:00–04:00: nếu có chạy trong khung này -> +250k
     * (Tạm demo, sau này anh có thể refine lại theo nghiệp vụ chính thức)
     */
    calcOtPay(start, end) {
      let total = 0;
      if (!(start instanceof Date) || !(end instanceof Date)) return 0;
      if (end <= start) return 0;

      const day = new Date(start);
      day.setHours(0, 0, 0, 0);

      const t17 = new Date(day);
      t17.setHours(17, 0, 0, 0);

      const t24 = new Date(day);
      t24.setDate(t24.getDate() + 1);
      t24.setHours(0, 0, 0, 0);

      const t00 = new Date(t24); // midnight
      const t02 = new Date(t24);
      t02.setHours(2, 0, 0, 0);
      const t04 = new Date(t24);
      t04.setHours(4, 0, 0, 0);

      // 1. 17h–24h: 36k / giờ
      const bandStart1 = start < t17 ? t17 : start;
      const bandEnd1 = end > t24 ? t24 : end;
      if (bandEnd1 > bandStart1) {
        const hours = (bandEnd1 - bandStart1) / (1000 * 60 * 60);
        total += hours * 36000;
      }

      // 2. 0h–2h: nếu có overlap -> 100k
      if (end > t00 && start < t02) {
        total += 100000;
      }

      // 3. 2h–4h: nếu có overlap -> 250k
      if (end > t02 && start < t04) {
        total += 250000;
      }

      return Math.round(total);
    },
  },
  created() {
    this.loadVehiclesAndOrders();
    this.loadWaitingOrders();
  },

};
</script>

<style scoped>
.page-wrapper {
  padding-top: 55px;
}

/* Summary cards */
.stat-card {
  border-radius: 0.75rem;
}
.stat-label {
  font-size: 0.8rem;
  text-transform: uppercase;
  color: #6c757d;
}
.stat-value {
  font-size: 1.4rem;
  font-weight: 700;
}
.stat-sub {
  font-size: 0.8rem;
  color: #6c757d;
  margin-top: 0.5rem;
}
.stat-icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  color: #fff;
}
.stat-icon-blue {
  background: #007bff;
}
.stat-icon-green {
  background: #28a745;
}
.stat-icon-orange {
  background: #fd7e14;
}
.stat-icon-purple {
  background: #6f42c1;
}

.list-group-item.active {
  background-color: #007bff;
  border-color: #007bff;
  color: #fff;
}
.list-group-item.active .text-muted {
  color: #e0e0e0 !important;
}

/* Modal override cho bootstrap */
.modal {
  background: rgba(0, 0, 0, 0.3);
}
</style>
